import { IAttrValue } from "@multiweb/types/contracts";
import { Globalization } from "Global/Dom/Globalization";
import { DateTimeFormatObject, DateUtils } from "../../../../Global/Base/Utils/DateUtils";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { DateTimeEdit } from "../../../UI.BaseControls/DateTimeEdit";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DefaultEditTemplate } from "../Templates/DataTypeEditTemplates/DefaultEditTemplate";
import { ItemTemplate } from "../Templates/ItemTemplate";
import { Column } from "./Column";

export class DateTimeColumn extends Column {
    //#region Fields
    protected static _formatFncs: Map<string, DateTimeFormatObject> = new Map<string, DateTimeFormatObject>();
    //#endregion

    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (!(val instanceof Date))
            return "";

        const cultureFormatter = {
            format(date: Date): string {
                const dateString = date.toLocaleString(Globalization.actualCulture);
                return dateString.substring(0, dateString.length - 3); // odstraňuje sekundy
            },
        };

        if (this.displayFormat && !DateTimeColumn._formatFncs.has(this.displayFormat)) {
            DateTimeColumn._formatFncs.set(this.displayFormat, DateUtils.getDateToStringFunction(this.displayFormat));
        } else if (!this.displayFormat) {
            DateTimeColumn._formatFncs.set(Globalization.actualCulture, cultureFormatter);
        }

        const fncs = DateTimeColumn._formatFncs.get(this.displayFormat ?? Globalization.actualCulture);

        return fncs.format(val);
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ItemTemplate();
        this.editItemTemplate = new DefaultEditTemplate(DateTimeEdit);
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-datetimecolumn", DateTimeColumn);
